import { render, staticRenderFns } from "./ImageBox.vue?vue&type=template&id=2b340106&scoped=true&"
import script from "./ImageBox.vue?vue&type=script&lang=js&"
export * from "./ImageBox.vue?vue&type=script&lang=js&"
import style0 from "./ImageBox.vue?vue&type=style&index=0&id=2b340106&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b340106",
  null
  
)

export default component.exports